/******************************************************************************************
 *	License Admin Search Service
 ********************************************************************************************/
(function() {
  

  angular
    .module('rcServices.licenseAdminSearch', [])

    //Search criteria types
    //The search criteria dropdown contains a mix of reseller and customer filters.
    //Each type has a different JIL endpoint. The constant object is used to differentiate between them
    //and set URL accordingly
    .constant('LICENSE_ADMIN_SEARCH_TYPES', {
      RESELLER: 1,
      CUSTOMER: 2
    })

    //License Admin Search Criteria Dropdown options
    .service(
      'LicenseAdminSearchCriteria',
      /* @ngInject */
      function(_, LICENSE_ADMIN_SEARCH_TYPES) {
        var options = [
          {
            value: 'salesforce_id',
            label: 'licenseAdminSearch.searchCriteria.resellerID',
            categoryLabel: 'licenseAdminSearch.searchCriteriaGroups.resellers',
            searchType: LICENSE_ADMIN_SEARCH_TYPES.RESELLER
          },
          {
            value: 'reseller_name',
            label: 'licenseAdminSearch.searchCriteria.resellerName',
            categoryLabel: 'licenseAdminSearch.searchCriteriaGroups.resellers',
            searchType: LICENSE_ADMIN_SEARCH_TYPES.RESELLER
          },
          {
            value: 'reseller_email',
            label: 'licenseAdminSearch.searchCriteria.resellerEmail',
            categoryLabel: 'licenseAdminSearch.searchCriteriaGroups.resellers',
            searchType: LICENSE_ADMIN_SEARCH_TYPES.RESELLER
          },
          {
            value: 'vip',
            label: 'licenseAdminSearch.searchCriteria.customerVIP',
            categoryLabel: 'licenseAdminSearch.searchCriteriaGroups.customers',
            searchType: LICENSE_ADMIN_SEARCH_TYPES.CUSTOMER
          },
          {
            value: 'customer',
            label: 'licenseAdminSearch.searchCriteria.customerName',
            categoryLabel: 'licenseAdminSearch.searchCriteriaGroups.customers',
            searchType: LICENSE_ADMIN_SEARCH_TYPES.CUSTOMER
          },
          {
            value: 'contact',
            label: 'licenseAdminSearch.searchCriteria.customerEmail',
            categoryLabel: 'licenseAdminSearch.searchCriteriaGroups.customers',
            searchType: LICENSE_ADMIN_SEARCH_TYPES.CUSTOMER
          }
        ];

        this.getOptions = function() {
          return options;
        };
        this.getResellerOnlyOptions = function() {
          return _.filter(options, ['searchType', LICENSE_ADMIN_SEARCH_TYPES.RESELLER]);
        };

        //Check if `searchType` is reseller or customer
        this.isReseller = function(searchType) {
          return searchType === LICENSE_ADMIN_SEARCH_TYPES.RESELLER;
        };
        this.isCustomer = function(searchType) {
          return searchType === LICENSE_ADMIN_SEARCH_TYPES.CUSTOMER;
        };
      }
    )
    .service(
      'LicenseAdminSearch',
      /* @ngInject */
      function(_, LICENSE_ADMIN_SEARCH_TYPES, jilResellerCustomers, jilResellers) {
        this.get = function(searchType, payload) {
          if (searchType === LICENSE_ADMIN_SEARCH_TYPES.RESELLER) {
            return jilResellers.resellers.query(payload).$promise;
          } else {
            //Fallback to customer search (random pick) so that the AJAX call is made and
            //the method returns the same promise as expected by outside world
            return jilResellerCustomers.anyCustomers.query(payload).$promise;
          }
        };
      }
    );
})();
